import React from 'react'
import PropTypes from 'prop-types'

const HelpIcon = (props) => {
  const { color = '#000000', classes = 'w-20' } = props

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_646_598)">
        <path
          d="M9.16602 15.0003H10.8327V13.3337H9.16602V15.0003ZM9.99935 1.66699C5.39935 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39935 18.3337 9.99935 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 5.40033 14.5993 1.66699 9.99935 1.66699ZM9.99935 16.667C6.32435 16.667 3.33268 13.6753 3.33268 10.0003C3.33268 6.32533 6.32435 3.33366 9.99935 3.33366C13.6743 3.33366 16.666 6.32533 16.666 10.0003C16.666 13.6753 13.6743 16.667 9.99935 16.667ZM9.99935 5.00033C8.15768 5.00033 6.66602 6.49199 6.66602 8.33366H8.33268C8.33268 7.41699 9.08268 6.66699 9.99935 6.66699C10.916 6.66699 11.666 7.41699 11.666 8.33366C11.666 10.0003 9.16602 9.79199 9.16602 12.5003H10.8327C10.8327 10.6253 13.3327 10.417 13.3327 8.33366C13.3327 6.49199 11.841 5.00033 9.99935 5.00033Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_646_598">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

HelpIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(HelpIcon)
